// © Microsoft Corporation. All rights reserved.

import { IMockManager, MockConfigDictionary } from "@msnews/core-contracts";

import { getLocationSearch } from "@msnews/isomorphic-util";

export class MockManager implements IMockManager {
    /** Indicates if mock is requested*/
    private _mocksEnabled = false;

    private _mockConfigDictionary: MockConfigDictionary = {};

    /**
     * Initialize mock manager
     */
    constructor() {
        this._mockConfigDictionary = this.createMockDictionary();
        this._mocksEnabled = Object.keys(this._mockConfigDictionary).length !== 0;
    }

    /**
     * Returns the list of mocked config list
     */
    public get mockConfigDictionary(): MockConfigDictionary {
        return this._mockConfigDictionary;
    }

    /**
     * Returns if mock was requested
     */
    public get mocksEnabled(): boolean {
        return this._mocksEnabled;
    }

    /**
     * Gets the list of mocks from QSP
     * eg: item= mock:river/default|river/mockinst returns what to mock (river/default) with replacement sought (river/mockinst)
     * This is used only in local dev/TEST scenario. Please do not use this for PROD scenarios
     * @returns Dictionary of mock configs sought to be replaced
     */
    private createMockDictionary(): MockConfigDictionary {
        // Get all parameters that begin with 'mock:'
        const itemParams = new URLSearchParams(getLocationSearch()).getAll("item").filter(item => /^mock:/.test(item));
        const mockConfigDictionary: MockConfigDictionary = {};

        itemParams.forEach((param) => {
            const [_, mockParam] = param.split(":");
            const [mockFrom, mockWith] = mockParam.split("|");
            mockConfigDictionary[mockFrom] = mockWith;
        });
        return mockConfigDictionary;
    }
}
export const mockManager = new MockManager();